export default __webpack_public_path__ + "static/Entenda0044-21d8b4de1e75c5461e00517c15e3e278.jpg";